export default __webpack_public_path__ + "static/media/UploadIcon.88965bcb.svg";